<template>
    <job>
    <div class="flex mb-6">
        <div class="mr-8">
            <img :data-src="job.company.logo" style="height:100px; width:100px; border-radius:5px;" class="card-img-bottom img-fluid lazyload" :alt="job.company.name">
        </div>
        <div class="w-3/4">
            <div class="flex">
                <div class="w-3/4">
                    <h1 class="mb-3 break-all">{{job.title}}</h1>
                </div>
                <div class="w-1/4">
                     <h6>Save <bookmark :job-id="job.id"/></h6>
                </div>
            </div>
            <p>{{ job.company.name }}</p>
            <button type="button" name="button" class="vs-component vs-button vs-button-success vs-button-filled mt-3">
                <span class="vs-button-backgroundx vs-button--background" style="opacity: 1; left: 49px; top: 27px; width: 0px; height: 0px; transition: width 0s ease 0s, height 0s ease 0s, opacity 0s ease 0s;"></span>
                <span class="vs-button-text vs-button--text">Apply Now</span>
                <span class="vs-button-linex" style="top: auto; bottom: -2px; left: 50%; transform: translate(-50%);"></span>
            </button>
        </div>
    </div>
    <vs-tabs>
        <vs-tab label="Job Details">
            <div class="tab-text text-editor-content break-all">
                {{ job.content }}
            </div>
        </vs-tab>
        <vs-tab label="Location">
            <div class="tab-text">
                Map goes here
            </div>
        </vs-tab>
        <vs-tab label="Company Overview">
            <div class="tab-text mt-6">
                <div class="flex">
                    <div v-if="job.company.headquarters" class="w-1/3">
                        <p class="font-bold">HEADQUARTERS</p>
                        <p>{{ job.company.headquarters }}</p>
                    </div>
                    <div v-if="job.company.employees" class="w-1/3">
                        <p class="font-bold">EMPLOYEES</p>
                        <p>{{ job.company.employees }}</p>
                    </div>
                    <div class="w-1/3">
                        <p class="font-bold">INDUSTRY</p>
                        <p>{{ job.company.industry }}</p>
                    </div>
                </div>
                <div class="mt-6 text-editor-content">
                    {{ job.company.content }}
                </div>
            </div>
        </vs-tab>
    </vs-tabs>
</job>
</template>

<script>
export default {
    props : {
        job : {
            type : Object,
            required : true,
        }
    }
}
</script>

<style scoped>
.text-editor-content * {
    white-space: pre-wrap;
    white-space: -moz-pre-wrap;
    white-space: -pre-wrap;
    white-space: -o-pre-wrap;
    word-wrap: break-word;
    word-break: break-all;
}
</style>